export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./pagination.vue?vue&type=template&id=3ceb9f56&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/pagination/pagination.vue?vue&type=template&id=3ceb9f56&
// module id = 1208
// module chunks = 0